import React, { useEffect } from "react";
import "../styles/Hero.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import gsap from "gsap";

const Hero = ({ animate }) => {
  useEffect(() => {
    if (animate) {
      // Hide the hero text and scroll initially
      gsap.set("h1 .h1, .scroll-text, .reveal", { opacity: 0, y: 20 });

      // Create a timeline for the hero animation
      const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

      // Animate the hero text and scroll after Navbar animation
      tl.to("h1 .h1", {
        opacity: 1,
        y: 0,
        stagger: 0.3, // Delay between each h1 item
        duration: 0.8,
      })
        .to(
          ".scroll-text",
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
          },
          "-=0.5", // Overlap the scroll-text animation with the last h1 item
        )
        .to(
          ".reveal",
          {
            opacity: 1,
            y: 0,
            stagger: 0.3,
            duration: 0.8,
          },
          "-=0.3", // start slightly before scroll-text finishes
        );
    }
  }, [animate]); // Trigger animation once animate is true

  return (
    <div className="hero-section">
      <h1 className="hero-heading">
        <div className="line-1">
          <span className="h1">Learn.</span> {""} {""}
          <span className="h1">Drive.</span>
        </div>
        <div className="line-2">
          <span className="h1">Pass.</span>
        </div>
      </h1>
      <p className="hero-subtext reveal">Automatic & Manual Lessons</p>
      <div className="cta-and-contact reveal">
        {/* <button className="cta-button">Get Started</button> */}

        <div className="call-banner reveal">
          <p>
            Call now to book your first lesson:{" "}
            <span className="phone-number">07958142870</span>
          </p>
        </div>
      </div>

      {/* Mobile Version */}
      <div className="hero-text mobile" style={{ opacity: 0 }}>
        <h1>Auto DrivR</h1>
      </div>

      <h4 className="scroll-text" style={{ opacity: 0 }}>
        {" "}
        <FontAwesomeIcon icon={faArrowDown} flip className="arrow" />
      </h4>
    </div>
  );
};

export default Hero;
